import PortfolioItemContent from './PortfolioItemContent';

export default PortfolioItemContent;
